<!-- appendTo: o painel dos ng-select abre na janela do modal (position: fixed) para nao ser cortado
     pelo scroll do simplebar; em ecras baixos abria para cima e as primeiras opcoes ficavam inacessiveis.
     appCloseSelectsOnScroll fecha o painel quando o separador faz scroll, porque ja nao acompanha o campo. -->
<ngx-simplebar appCloseSelectsOnScroll class="px-3 mx-n3 mb-2" style="height: calc(100vh - calc(70px + 1.5rem + 60px + 125px));"
  [options]="{ forceVisible: true }">
  <form [formGroup]="propertyAddressForm" *ngIf="isView$.getValue()" #formElementRef>
    <div class="row">
      <div class="card">
        <div class="card-header border-0 align-items-center d-flex py-0">
          <h4 class="card-title mb-0 flex-grow-1"></h4>
          <div class="dropdown">
            <button class="btn btn-outline-primary waves-effect waves-primary btn-sm dropdown border-input-custom"
              type="button" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside"><i
                class=" ri-settings-2-line fs-14"></i>
            </button>
            <div class="border border-primary dropdown-menu dropdown-menu-end p-3 border-input-custom"
              style="min-width: 12rem;">
              <div class="d-flex flex-column gap-2 filter-check">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-address"
                    formControlName="hidePropertyAddress">
                  <label class="form-check-label" for="hide-address">
                    {{ 't-m-properties.t-hide-address' | translate }}
                  </label>
                </div>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-georeference"
                    formControlName="hideMap">
                  <label class="form-check-label" for="hide-georeference">
                    {{ 't-m-properties.t-hide-georeference' | translate }}
                  </label>
                </div>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-district"
                    formControlName="hideDistrict">
                  <label class="form-check-label" for="hide-district">
                    {{ 't-m-properties.t-hide-district' | translate }}
                  </label>
                </div>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-county"
                    formControlName="hideCounty">
                  <label class="form-check-label" for="hide-county">
                    {{ 't-m-properties.t-hide-county' | translate }}
                  </label>
                </div>
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" role="switch" id="hide-parish"
                    formControlName="hideParish">
                  <label class="form-check-label" for="hide-parish">
                    {{ 't-m-properties.t-hide-parish' | translate }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="countryInput" class="form-label">
                  {{ 't-m-properties.t-country' | translate }}

                </label>
                <ng-select appendTo=".modal-create-properties" [items]="countries" [multiple]="false"
                  placeholder="{{ 't-general.t-select' | translate }} {{ 't-m-properties.t-country' | translate }}"
                  bindLabel="name" bindValue="id" required formControlName="country"
                  [ngClass]="{ 'is-invalid': submitted && form['country'].errors  && form['country'].errors['required']  }"
                  (change)="changeCountry($event)" [clearable]="false"
                  [ngClass]="{ 'is-warning': submitted && form['country'].errors && form['country'].errors['warning'] }">
                </ng-select>
                <div *ngIf="submitted && form['country'].errors" class="invalid-feedback" align="left">
                  <div *ngIf="form['country'].errors['required']">
                    {{ 't-m-properties.t-country' | translate }}
                    {{ 't-general.t-is-required'|translate }}
                  </div>
                </div>
              </div>
            </div>
            <!--end col-->

            <div class="col-lg-4">
              <div class="mb-3">
                <label for="regionInput" class="form-label">
                  {{ 't-m-properties.t-region' | translate }}
                </label>
                <ng-select appendTo=".modal-create-properties" [items]="regions" [multiple]="false"
                  placeholder="{{ 't-general.t-select' | translate }}  {{ 't-m-properties.t-region' | translate }}"
                  bindLabel="name" bindValue="id" required formControlName="region"
                  [ngClass]="{ 'is-invalid': submitted && form['region'].errors  && form['region'].errors['required'] }"
                  [ngClass]="{ 'is-warning': submitted && form['region'].errors && form['region'].errors['warning'] }"
                  (change)="changeRegion($event)" [clearable]="false">
                </ng-select>
                <div *ngIf="submitted && form['region'].errors" class="invalid-feedback" align="left">
                  <div *ngIf="form['region'].errors['required']">
                    {{ 't-m-properties.t-region' | translate }}
                    {{ 't-general.t-is-required'|translate }}
                  </div>
                </div>
              </div>
            </div>
            <!--end col-->
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="districtInput" class="form-label">
                  {{ 't-m-properties.t-district' | translate }}
                </label>
                <ng-select appendTo=".modal-create-properties" [items]="districts" [multiple]="false"
                  placeholder="{{ 't-general.t-select' | translate }} {{ 't-m-properties.t-district' | translate }}"
                  bindLabel="name" bindValue="id" required formControlName="district"
                  [ngClass]="{ 'is-invalid': submitted && form['district'].errors  && form['district'].errors['required'] }"
                  (change)="changeDistrict($event)" [clearable]="false"
                  [ngClass]="{ 'is-warning': submitted && form['district'].errors && form['district'].errors['warning'] }">
                </ng-select>
                <div *ngIf="submitted && form['district'].errors" class="invalid-feedback" align="left">
                  <div *ngIf="form['district'].errors['required']">
                    {{ 't-m-properties.t-district' | translate }}
                    {{ 't-general.t-is-required'|translate }}
                  </div>
                </div>
              </div>
            </div>
            <!--end col-->
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="countyInput" class="form-label">
                  {{ 't-m-properties.t-county' | translate }}
                </label>
                <ng-select appendTo=".modal-create-properties" [items]="counties" [multiple]="false"
                  placeholder="{{ 't-general.t-select' | translate }}  {{ 't-m-properties.t-county' | translate }}"
                  bindLabel="name" bindValue="id" required formControlName="county"
                  [ngClass]="{ 'is-invalid': submitted && form['county'].errors && form['county'].errors['required'] }"
                  (change)="changeCounty($event)" [clearable]="false"
                  [ngClass]="{ 'is-warning': submitted && form['county'].errors && form['county'].errors['warning'] }">
                </ng-select>
                <div *ngIf="submitted && form['county'].errors" class="invalid-feedback" align="left">
                  <div *ngIf="form['county'].errors['required']">
                    {{ 't-m-properties.t-county' | translate }}
                    {{ 't-general.t-is-required'|translate }}
                  </div>
                </div>
              </div>
            </div>
            <!--end col-->
            <div class="col-lg-4">
              <div class="mb-3">
                <label for="parishInput" class="form-label">
                  {{ 't-m-properties.t-parish' | translate }}
                </label>
                <ng-select appendTo=".modal-create-properties" class="parish-select" [items]="parishes" [multiple]="false" (change)="autoRefreshGeoreference()"
                  placeholder="{{ 't-general.t-select' | translate }}  {{ 't-m-properties.t-parish' | translate }}"
                  bindLabel="name" bindValue="id" required formControlName="parish"
                  [ngClass]="{ 'is-invalid': submitted && form['parish'].errors && form['parish'].errors['required']  }"
                  [clearable]="false"
                  [ngClass]="{ 'is-warning': submitted && form['parish'].errors && form['parish'].errors['warning'] }">
                </ng-select>
                <div *ngIf="submitted && form['parish'].errors" class="invalid-feedback" align="left">
                  <div *ngIf="form['parish'].errors['required']">
                    {{ 't-m-properties.t-parish' | translate }}
                    {{ 't-general.t-is-required'|translate }}
                  </div>
                </div>
                <div *ngIf="showOutdatedParishNotice" class="form-text text-muted" align="left">
                  <i class="ri-error-warning-line align-bottom"></i>
                  {{ 't-m-properties.t-outdated-parish' | translate }}
                </div>
              </div>
            </div>
            <!--end col-->
          </div>
          <!--end row-->
        </div>
      </div>
    </div>
    <!--end row-->
    <div class="row">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <!--end col-->
            <div class="col-lg-6">
              <div class="mb-3">
                <label for="addressInput" class="form-label">
                  {{ 't-m-properties.t-address' | translate }}
                </label>
                
                <input type="text" class="form-control" id="addressInput" (change)="autoRefreshGeoreference()"
                  placeholder="  {{ 't-enter' | translate }} {{ 't-m-properties.t-address' | translate }}"
                  formControlName="address"
                  [ngClass]="{ 'is-warning': submitted && form['address'].errors && form['address'].errors['warning'] }" />
              </div>
            </div>
            <!--end col-->

            <div class="col-lg-3">
              <div class="mb-3">
                <label for="zipcodeInput" class="form-label">
                  {{ 't-m-properties.t-zip-code' | translate }}
                </label>

                <input type="text" class="form-control" id="zipcodeInput" [placeholder]="postalCodeFormat"
                  [mask]="postalCodeFormat" formControlName="zipCode" (change)="autoRefreshGeoreference()"
                  [ngClass]="{ 'is-warning': submitted && form['zipCode'].errors && form['zipCode'].errors['warning'] }" />
              </div>
            </div>

            <div class="col-lg-3">
              <div class="mb-3">
                <label for="zoneInput" class="form-label">
                  {{ 't-m-properties.t-zone' | translate }}
                </label>

                <input type="text" class="form-control" id="zoneInput" maxlength="255"
                  placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-zone' | translate }}"
                  formControlName="zone" />
              </div>
            </div>
            <!--end col-->
          </div>
          <!--end row-->

          <div class="row">
            <div class="col-lg-3">
              <div class="mb-3">
                <label for="doorInput" class="form-label">
                  {{ 't-m-properties.t-door' | translate }}
                </label>

                <input type="text" class="form-control" id="doorInput"
                  placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-door' | translate }}"
                  formControlName="doorNumber" />
              </div>
            </div>
            <!--end col-->

            <div class="col-lg-3">
              <div class="mb-3">
                <label for="fractionInput" class="form-label">
                  {{ 't-m-properties.t-fraction' | translate }}
                </label>

                <input type="text" class="form-control" id="fractionInput"
                  placeholder="{{ 't-enter' | translate }} {{ 't-m-properties.t-fraction' | translate }}"
                  formControlName="fraction" />
              </div>
            </div>
            <!--end col-->

            <div class="col-lg-3">
              <div class="mb-3">
                <label for="floorInput" class="form-label">
                  {{ 't-m-properties.t-floor' | translate }}
                </label>
                <input type="text" class="form-control" id="floorInput"
                  placeholder=" {{ 't-enter' | translate }}  {{ 't-m-properties.t-floor' | translate }}"
                  formControlName="floor">
              </div>
            </div>
            <!--end col-->
          </div>
          <!--end row-->
        </div>
      </div>
      <!-- end card -->
    </div>
    <!--end row-->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="align-items-center card-header d-flex pb-2">
            <h4 class="card-title mb-0">
              {{ 't-m-properties.t-geo-reference' | translate }}
            </h4>
            <div class="ms-2">
              <button *ngIf="!validateLocationBtn()"
                ngbTooltip="{{form['country'].value && form['country'].value !== portugalCountry?.id ? ('t-georeference-tooltip-nozip' | translate) : ('t-georeference-tooltip' | translate)}}"
                class="btn p-0"><i class="fs-18 mdi mdi-refresh"></i></button>
              <button *ngIf="validateLocationBtn()" (click)="refreshGeoreference()" class="btn p-0"><i
                  class="fs-18 mdi mdi-refresh"></i></button>
            </div>

            <button type="button"
              class="btn btn-link btn-sm text-muted p-0 ms-auto text-decoration-none"
              (click)="toggleManualCoordinates()">
              {{ 't-m-properties.t-manual-coordinates' | translate }}
              <i class="align-middle"
                [ngClass]="showManualCoordinates ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'"></i>
            </button>
          </div><!-- end card header -->

          <div class="card-body">
            <!-- <div style="height: 300px;" leaflet [leafletOptions]="options"  (leafletMapReady)="onMapReady($event)">
                        <div [leafletLayers]="markersLayers"></div>
                    </div> -->
            <div class="row g-2 mb-3" *ngIf="showManualCoordinates">
              <div class="col-md-6">
                <label class="form-label" for="latitude">{{ 't-latitude' | translate }}</label>
                <input id="latitude" class="form-control" type="number" step="any" formControlName="latitude"
                  (focus)="onManualCoordinateFocus()" (input)="onManualCoordinateChange()"
                  (blur)="onManualCoordinateBlur()" placeholder="38.7223" />
              </div>

              <div class="col-md-6">
                <label class="form-label" for="longitude">{{ 't-longitude' | translate }}</label>
                <input id="longitude" class="form-control" type="number" step="any" formControlName="longitude"
                  (focus)="onManualCoordinateFocus()" (input)="onManualCoordinateChange()"
                  (blur)="onManualCoordinateBlur()" placeholder="-9.1393" />
              </div>

              <div class="col-12">
                <div class="text-danger fs-12" *ngIf="manualCoordsInvalid">
                  {{ 't-m-properties.t-manual-coordinates-invalid' | translate }}
                </div>
                <div class="form-text text-muted" *ngIf="!manualCoordsInvalid">
                  {{ 't-m-properties.t-manual-coordinates-hint' | translate }}
                </div>
              </div>
            </div>
            <div class="map-container" leaflet [leafletOptions]="options" (leafletMapReady)="onMapReady($event)"
              (leafletDoubleClick)="mapDblClick($event)" style="height: 300px;">
            </div>
          </div>
          <!-- end card-body -->
        </div><!-- end card -->
      </div>
      <!-- end col -->
    </div>
  </form>
</ngx-simplebar>